import { Theme } from '@mui/material';

const Chip = (theme: Theme) => {
  return {
    MuiChip: {
      variants: [
        {
          props: { color: 'success' },
          style: {
            backgroundColor: '#dcfce7',
            color: '#166434',
          },
        },
      ],
    },
  };
};

export default Chip;
